<template>
  <div :class="styles" class="rounded-lg px-3 py-2 font-size-3" v-html="text"/>
</template>

<script>
  import { getQueryStringParams } from '../../lib/utils';

  export default {
    name: 'TextMessage',
    props: {
      text: {
        required: true,
        type: String
      },
      owner: {
        required: true,
        type: String
      }
    },
    computed: {
      styles() {
        const {owner} = this;
        const params = getQueryStringParams(); 
        if(params && params['shoppingSlug'] === 'vlm'){
          return {
            'bg-vlm': owner === 'user',
            'bg-gray-100': owner === 'bot',
            'text-light': owner === 'user'
          };
        } else {
          return {
            'bg-primary': owner === 'user',
            'bg-gray-100': owner === 'bot',
            'text-light': owner === 'user'
          };
        }
      }
    }
  };
</script>

<style scoped></style>
